import { Controller } from "stimulus"

export default class extends Controller {
  static values = { id:String }
  connect(){
    window.location.assign('/grupperom/'+this.idValue);
  }
}
